import { Button } from 'antd';
import { PropTypes } from 'prop-types';
import React from 'react';
import './index.less';

const buttonLinkDefaultPropOnClick = () => {};

const ButtonLink = ({
  onClick = buttonLinkDefaultPropOnClick,
  size = 'medium',
  className = undefined,
  text = undefined,
  id = undefined,
}) => (
  <Button
    className={className ? `${className} gg-button-link` : 'gg-button-link'}
    onClick={onClick}
    data-testid={id}
    size={size}
    type="link"
  >
    {text}
  </Button>
);

ButtonLink.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default ButtonLink;
